module.exports = global["VirtualMachine"] = require("-!./index.js");